import { UPDATE_SCHICHTTAUSCHANTRAG } from '@/domain/navigation/benachrichtigungen/graphql/mutations';
import {
  Navigation_UpdateSchichttauschantragMutation,
  Navigation_UpdateSchichttauschantragMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useUpdateSchichttauschantrag() {
  const [execute, result] = useMutation<
    Navigation_UpdateSchichttauschantragMutation,
    Navigation_UpdateSchichttauschantragMutationVariables
  >(UPDATE_SCHICHTTAUSCHANTRAG, {
    refetchQueries: ['GetBenachrichtigungen'],
  });

  const updateSchichttauschantrag = useCallback(
    (variables: Navigation_UpdateSchichttauschantragMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );
  return [updateSchichttauschantrag, result] as const;
}
